import React from 'react';
import AppImage from '@/components/ui/AppImage';
import { Link } from 'react-router-dom';
import Icon from '@/components/ui/AppIcon';
export default function ContactHero() {
    return (<section className="relative min-h-[40vh] flex items-end overflow-hidden" aria-label="Contact page hero">
      <AppImage src="/assets/images/images__2_-1787466616168.jpeg" alt="Elegant event venue with golden chandelier lighting, deep warm amber tones, dark sophisticated interior, empty stage ready for performance" fill priority sizes="100vw" className="object-cover object-center"/>

      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/30"/>
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-black/40"/>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-12 pt-32">
        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4">
          <Link to="/" className="hover:text-primary transition-colors">Home</Link>
          <Icon name="ChevronRightIcon" size={12}/>
          <span className="text-primary">Contact</span>
        </div>
        <p className="section-label mb-3">Get In Touch</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-foreground leading-tight max-w-xl">
          Let&apos;s <span className="gold-gradient">Connect</span>
        </h1>
        <p className="text-foreground/70 text-base mt-4 max-w-lg leading-relaxed">
          Have a question about an event or want to collaborate? We&apos;d love to hear from you.
        </p>
      </div>
    </section>);
}
